<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M14.8978 8.81022C14.8978 5.12832 11.913 2.14355 8.23112 2.14355C4.54922 2.14355 1.56445 5.12832 1.56445 8.81022C1.56445 12.4921 4.54922 15.4769 8.23112 15.4769C11.913 15.4769 14.8978 12.4921 14.8978 8.81022Z"
      stroke="currentColor"
    />
    <path
      d="M8.39128 12.1436V8.81022C8.39128 8.49595 8.39128 8.33882 8.29361 8.24115C8.19601 8.14355 8.03888 8.14355 7.72461 8.14355"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.22461 6.14355H8.23061"
      stroke="currentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>